 let Popmask;
 let VideoPopups =  document.querySelector(".template-page");
  function PopImageProduct(e,clickID) {
    let targetDoms  = document.getElementById(clickID).dataset.id
    Popmask = document.getElementById(targetDoms);
    Popmask.classList.remove("hide");
    VideoPopups.classList.add("overflow-new")
    let autoVideoPC = document.getElementById(clickID).dataset.setid
    console.log(document.getElementById(clickID).dataset.setid,"hahahahh")
    let videoPopupsvideo = document.getElementById(autoVideoPC)
    
    videoPopupsvideo.play();
    
}
  function PopImageProductclose() {
 
     Popmask.classList.add('hide');
    VideoPopups.classList.remove("overflow-new")
  
}

